import { QRCodeSVG } from "qrcode.react";
import { useEffect } from "react";
import Accordion from "../../common/accordion/Accordion";
import { faqContent1, faqContent2 } from "../../constants/FAQ";
import SEOHead from "../seo/seo-header";

function DownloadPage() {
  // /pages/download.tsx (Next.js) or use plain HTML/JS page
  useEffect(() => {
    const userAgent = navigator.userAgent || (window as any).opera;
    if (/android/i.test(userAgent)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.facebook.katana&hl=en";
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.location.href =
        "https://apps.apple.com/ng/app/facebook/id284882215"; // or your app
    }
  }, []);

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    logo: "https://shiga.io/shiga-logo.png",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.shiga.io",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Download",
        item: "https://www.shiga.io/download",
      },
    ],
  };

  const downloadUrl = " http://192.168.0.163:3000/download";

  return (
    <>
      <SEOHead
        title="Download - Shiga | Borderless finance. Always with you."
        description="  Download the Shiga app and send, receive, swap or pay using stablecoins—anytime, anywhere."
        structuredData={breadcrumbData}
        canonicalUrl="https://www.shiga.io/download"
      />

      <div className="bg-white">
        <div className="w-full pt-[140px]  bg-hbrand-25">
          <div className="max-content">
            <div className="container">
              <div className="overflow-hidden w-full flex justify-between h-full mdxl:flex-col  mdxl:items-center">
                <div className="w-[491px] xlsm:w-full pb-[62px] mdxl:pb-0">
                  <h1 className="text-[40px] leading-[48px] font-satoshi font-[900] text-hgray-950">
                    Borderless finance. Always with you.{" "}
                  </h1>
                  <p className="mt-[32px] xlsm:mt-[12px] text-[20px] leading-[24px] font-satoshi font-[400] text-hgray-950">
                    Download the Shiga app and send, receive, swap or pay using
                    stablecoins—anytime, anywhere.
                  </p>

                  <div className="mt-[32px] pb-[32px] mdxl:pb-0 mdxl:border-none border-b-[1px] border-[#E4E7EC] cursor-pointer flex w-full flex-wrap gap-[16px] mdxl:flex-col">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.facebook.katana&hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="/assets/google.svg"
                        alt="line"
                        className="h-[44px] w-[153px]"
                      />
                    </a>
                    <a
                      href="https://apps.apple.com/ng/app/facebook/id284882215"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="/assets/ios.svg"
                        alt="line"
                        className="h-[44px] w-[153px]"
                      />
                    </a>
                    <a href="https://business.shiga.io/signup">
                      <img
                        src="/assets/webIcon.svg"
                        alt="line"
                        className="h-[44px] w-[153px]"
                      />
                    </a>
                  </div>

                  <div className="mt-[32px] mdxl:hidden block flex items-center gap-[40px] h-[120px] xlsm:h-[44px]">
                    <div className="xlsm:hidden block flex items-center gap-[16px]">
                      <div className="">
                        <QRCodeSVG value={downloadUrl} size={96} level="H" />
                      </div>
                      <p className="w-[237px] text-[16px] leading-[24px] font-satoshi font-[500] text-htext-subdued">
                        Or scan this QR code with your phone’s camera to
                        download on iOS or Android{" "}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="h-full mdxl:h-[420px] xlsm:h-[200px] mdxl:w-full relative mdxl:flex mdxl:justify-end">
                  <img
                    src="/assets/phone.png"
                    alt=""
                    className="w-[526px] h-[516px] xlsm:hidden mdxl:absolute mdxl:-top-[90px]"
                  />
                  <img
                    src="/assets/phoneSm.png"
                    alt=""
                    className="h-[290px] hidden xlsm:block mdxl:absolute mdxl:-top-[90px] w-[295px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className=" w-full h-full pt-[120px] pb-[250px] mdxl:pt-[60px] mdxl:pb-[300px] bg-white">
          <div className="max-content">
            <div className="container">
              <div className={``}>
                <h2 className="faq-header font-satoshi font-black text-hgray-950 text-[43.5px] text-start">
                  FAQ
                </h2>
                <div
                  className={`w-full flex items-start justify-between flex-wrap mt-6 mdxl:flex-col`}
                >
                  {/* First Column of FAQs */}
                  <div
                    className={`flex flex-col items-start justify-center w-[48%] mdxl:w-full `}
                  >
                    <Accordion item={faqContent1} />
                  </div>

                  {/* Second Column of FAQs */}
                  <div
                    className={`flex flex-col items-start justify-center w-[48%] mdxl:w-full`}
                  >
                    <Accordion item={faqContent2} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default DownloadPage;
